import {FC} from 'react';
//formik
import {Field} from 'formik';
//mui
import {Box, Typography} from '@mui/material';
//components
import DatePicker from '@/shared/components/DatePicker';
import TimePicker from '@/shared/components/TimePicker';
//constants
import {FIELD, FIELD_LABEL, SUBTITLE1} from '@/utils/constants';
//helpers
import {setRequiredLabel} from '@/utils/helpers';
//styles
import {ticketsSalesStyle} from './TicketsSales.styles';

const TicketsSales: FC = () => {
	return (
		<Box sx={ticketsSalesStyle.wrapper}>
			<Box>
				<Typography variant={SUBTITLE1} sx={ticketsSalesStyle.title}>
					Start Sales On:
				</Typography>
				<Box sx={ticketsSalesStyle.date}>
					<Field
						id={FIELD.ticketsSalesStartDate}
						name={FIELD.ticketsSalesStartDate}
						label={setRequiredLabel(FIELD_LABEL.startDate)}
						component={DatePicker}
						sx={ticketsSalesStyle.dateMonthYear}
					/>
					<Field
						id={FIELD.ticketsSalesStartTime}
						name={FIELD.ticketsSalesStartTime}
						label={setRequiredLabel(FIELD_LABEL.startTime)}
						component={TimePicker}
						parentClassName={ticketsSalesStyle.time}
					/>
				</Box>
			</Box>
			<Box>
				<Typography variant={SUBTITLE1} sx={ticketsSalesStyle.title}>
					Stop Sales On:
				</Typography>
				<Box sx={ticketsSalesStyle.date}>
					<Field
						id={FIELD.ticketsSalesEndDate}
						name={FIELD.ticketsSalesEndDate}
						label={setRequiredLabel(FIELD_LABEL.endDate)}
						component={DatePicker}
						sx={ticketsSalesStyle.dateMonthYear}
					/>
					<Field
						id={FIELD.ticketsSalesEndTime}
						name={FIELD.ticketsSalesEndTime}
						label={setRequiredLabel(FIELD_LABEL.endTime)}
						component={TimePicker}
						parentClassName={ticketsSalesStyle.time}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default TicketsSales;
